import DistanceViewModel from '@/models/Shared/DistanceViewModel';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto';

export default class LocationSearchViewModel {
    locationTypes: LocationTypeDto[] = []
    selectedLocationTypes: LocationTypeDto[] = [];
    workers: WorkerProfileDto[] = [];
    selectedWorker: WorkerProfileDto;
    distanceOptions: DistanceViewModel[] = [];
    selectedDistance: DistanceViewModel;

    public constructor(locationTypes: LocationTypeDto[], selectedDistance: DistanceViewModel) {
        this.locationTypes = locationTypes;
        this.distanceOptions.push(new DistanceViewModel(1, "1"));
        this.distanceOptions.push(new DistanceViewModel(2, "2"));
        this.distanceOptions.push(new DistanceViewModel(3, "3"));
        this.distanceOptions.push(new DistanceViewModel(4, "4"));
        this.distanceOptions.push(new DistanceViewModel(5, "5"));
        this.distanceOptions.push(new DistanceViewModel(6, "6"));
        this.distanceOptions.push(new DistanceViewModel(7, "7"));
        this.distanceOptions.push(new DistanceViewModel(8, "8"));
        this.distanceOptions.push(new DistanceViewModel(9, "9"));
        this.distanceOptions.push(new DistanceViewModel(10, "10"));
        this.distanceOptions.push(new DistanceViewModel(15, "15"));
        this.distanceOptions.push(new DistanceViewModel(20, "20"));
        this.distanceOptions.push(new DistanceViewModel(25, "25"));
        this.distanceOptions.push(new DistanceViewModel(30, "30"));
        this.distanceOptions.push(new DistanceViewModel(35, "35"));
        this.distanceOptions.push(new DistanceViewModel(40, "40"));
        this.distanceOptions.push(new DistanceViewModel(45, "45"));
        this.distanceOptions.push(new DistanceViewModel(50, "50"));
        this.distanceOptions.push(new DistanceViewModel(0, "Unlimited"));
        this.selectedDistance = selectedDistance;
    }
}